module.exports = __webpack_public_path__ + "img/dry-e230485.jpg";